import { translate } from "app/language/service"
import { getStore } from "app/store/store"
import { ICampaign } from "campaign/model"
import { campaignRPO } from "campaign/repository"
import { campaignActionCreator } from "campaign/store/actions"
import { messageSVC } from "message/service"

// a forecast/dsp-deal cannot be paused, so here only campaigns
export function setCampaignPause(
  campaignId: number,
  campaignName: string,
  pause: boolean,
  refreshList: boolean
): Promise<boolean> {
  return new Promise<boolean>((resolve, reject) => {
    messageSVC.confirmMessage({
      title: translate(pause ? "campaign.pause.title" : "campaign.unpause.title"),
      addGenericConfirmMessage: true,
      message: translate(
        pause ? "campaign.pause.confirm.message" : "campaign.unpause.confirm.message",
        campaignName || ""
      ),
      onSuccess: async () => {
        const updatedCampaign = await campaignRPO.update({ id: campaignId, is_paused: pause })
        if (refreshList) {
          refreshCampaignListInStore(updatedCampaign, false)
        }
        resolve(true)
      },
      onCancel: () => resolve(false)
    })
  })
}

// only used for campaign (not for forecast)
export function refreshCampaignListInStore(campaign: ICampaign, isDspDeal: boolean): void {
  const filteredEntities = isDspDeal
    ? getStore().getState().campaign.dspDealList.filteredEntities
    : getStore().getState().campaign.campaignList.filteredEntities
  getStore().dispatch(
    campaignActionCreator.setList(false, isDspDeal, {
      filteredEntities: filteredEntities.map(e => (e.id === campaign.id ? campaign : e))
    })
  )
}
